import {
    CrudOptions,
    DataManager,
    DataOptions,
    DataResult,
    Query,
    UrlAdaptor
} from '@syncfusion/ej2-data';

export class CustomUrlAdaptor extends UrlAdaptor {
    private statsCallback?: (stats: any) => void;

    constructor(props?: DataOptions, statsCallback?: (stats: any) => void) {
        let prop: DataOptions = { ...props };
        super(prop);
        this.statsCallback = statsCallback;
    }

    public override processResponse(
        data: DataResult & { stats?: any },  // extend type here
        ds?: DataOptions,
        query?: Query,
        xhr?: Request,
        request?: Object,
        changes?: CrudOptions
    ): DataResult {
        if (data.stats && this.statsCallback) {
            this.statsCallback(data.stats);
        }

        return {
            result: data.result || [],
            count: data.count || 0,
        };
    }

    public override convertToQueryString(req: any, query: Query, dm: DataManager): string {
        var res = [],
            respStr = '',
            tableName = req.table || '';
        delete req.table;
        if (dm.dataSource.requiresFormat) req['$format'] = 'json';
        for (var prop in req) res.push(prop + '=' + req[prop]);
        respStr = res.join('&');
        if (dm.dataSource.url && dm.dataSource.url.indexOf('?') !== -1 && !tableName)
            return respStr;
        respStr = respStr.replace(/[$]/g, '').replace(/select/, '$select');
        return respStr.length ? tableName + '?' + respStr : tableName || '';
    }
}
